import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { ThunkExtra } from '@app/store';
import { DynamicEntity } from '@app/types';
import {
  DashboardService,
  GetUserWidgetBirthdaysResponse,
  GetUserWidgetBirthdaysParams,
} from '@app/gen/dashboard';

import { DashboardState } from '../dashboard.state';

export const getBirthdaysList = createAsyncThunk<
  GetUserWidgetBirthdaysResponse,
  GetUserWidgetBirthdaysParams,
  ThunkExtra
>(
  'dashboard/getBirthdaysList',
  async (params, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getUserWidgetBirthdays({
        params,
      });

      return result;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const birthdaysReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getBirthdaysList.pending, (state) => {
    state.birthdays.status = 'loading';
  });
  builder.addCase(getBirthdaysList.fulfilled, (state, { payload }) => {
    state.birthdays.status = 'complete';
    state.birthdays.data = payload;
  });
  builder.addCase(getBirthdaysList.rejected, (state) => {
    state.birthdays.status = 'failed';
  });
};
